// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_7bbf52b8","outerContainer":"_447646a4","secondaryToolbar":"ff005ce0","doorHangerRight":"_25dbaae1","toolbarContainer":"ad4f284f","toolbarViewerMiddle":"_34e607ff","progressBar":"_6608b08b","back-to-application":"fad36f0d","card":"_797483ef","title":"_8e35f2aa","description":"c4e41413","cost":"b2bf2662","costLabel":"_881721d7","costAmount":"da31263d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualRoom/PaymentGate/styles.styl
// module id = 5149
// module chunks = 39